import React, { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import GoogleSignInButton from "@/components/GoogleSignInButton";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "admin@newearthos.org", password: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav("/admin/dashboard"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    const res = await login(f.email, f.password);
    setBusy(false);
    if (res.ok) { toast.success("Welcome back."); nav("/admin/dashboard"); }
    else toast.error(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-bone">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1568489711036-9c94a7d5aea6?crop=entropy&cs=srgb&fm=jpg&q=85" className="w-full h-full object-cover" alt="Sanctuary" />
        <div className="absolute inset-0 bg-forest/50" />
        <div className="absolute bottom-16 left-16 text-bone max-w-md">
          <div className="overline text-bone/70 mb-3">New Earth Operating System</div>
          <div className="font-serif text-4xl leading-tight">One home for the whole movement.</div>
        </div>
      </div>
      <div className="flex items-center justify-center px-8 py-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <Link to="/" className="overline">← Back to site</Link>
            <h1 className="font-serif text-4xl mt-4">Admin Portal</h1>
            <p className="text-ink-soft mt-2">Sign in to the operating system.</p>
          </div>
          <div><Label className="overline">Email</Label><Input type="email" required data-testid="login-email" value={f.email} onChange={e=>setF({...f, email: e.target.value})} /></div>
          <div><Label className="overline">Password</Label><Input type="password" required data-testid="login-password" value={f.password} onChange={e=>setF({...f, password: e.target.value})} /></div>
          <button type="submit" disabled={busy} data-testid="login-submit" className="pill pill-primary w-full justify-center">{busy ? "Signing in…" : "Sign in"}</button>
          <div className="relative py-2">
            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-line" /></div>
            <div className="relative flex justify-center"><span className="bg-bone px-3 text-xs uppercase tracking-widest text-ink-soft">or</span></div>
          </div>
          <GoogleSignInButton testId="admin-google-signin" returnPath="/admin/dashboard" className="w-full justify-center">Continue with Google</GoogleSignInButton>
        </form>
      </div>
    </div>
  );
}
